import DevicetManagementPage from "../pages/device_management";
import LoginPage from "../pages/login";
import ProductDetailPage from "../pages/product_detail";
import ProductManagementPage from "../pages/product_management";
import UserManagementPage from "../pages/user_management";

const routers = [
  {
    path: "/login",
    roleTarget: "ALL",
    element: LoginPage,
  },
  {
    path: "/user_management",
    roleTarget: "ALL",
    element: UserManagementPage,
  },
  {
    path: "/product_management",
    roleTarget: "ALL",
    element: ProductManagementPage,
  },
  {
    path: "/device_management",
    roleTarget: "ALL",
    element: DevicetManagementPage,
  },
  {
    path: "product_management/product_detail/:id",
    roleTarget: "ALL",
    element: ProductDetailPage,
  },
];
export default routers;
